import MaksimumSubmissionsService from '@/services/maksimumSubmissions';

export default {
	namespaced: true,
	state: {
	},

	getters: {
    
	},

	actions: {
		async getMaksimumSubmissions({commit, state, getters, dispatch}){
			try{
				const response = await MaksimumSubmissionsService.getMaksimumSubmissions();
				return response
			}catch(e){
				console.log(e)
			}
		}
	},

	mutations: {
		// SET_VALUE_FROM_API(state, payload) {
		// 	state.valueFromApi = payload;
		// }
	}
};
